import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    permissions: [],
    permission: {},
    new_permission: {},
  },
  actions,
  mutations,
  getters,
};
